import { render, staticRenderFns } from "./AssetBuyModal.vue?vue&type=template&id=3d81623c&"
import script from "./AssetBuyModal.vue?vue&type=script&lang=js&"
export * from "./AssetBuyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports